import { NextRouter } from "next/router";

export const baseUrlGeneration = (router: NextRouter) => {
  return typeof router.query?.city === "string" ? `/${router.query.city}` : "/";
};
